import { RiseOutlined } from '@ant-design/icons';
import { Card } from 'antd';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';

import TopContributorsStats from '../UsersGraphs/TopContributorsStats';
import TotalUsers from '../UsersGraphs/TotalUsers';

function UsersEngagementStats({ className }: { className?: string }) {
  const { t } = useTranslation('admin');

  return (
    <Card
      style={{
        borderRadius: 20,
      }}
      className={`${className}`}
    >
      <div className="flex flex-wrap items-start gap-x-6 gap-y-4 mb-8">
        <div className="grow">
          <h2 className="font-medium text-base">{t('users_engagement')}</h2>
        </div>
        <Link href="/?graph=users">
          <div className="flex items-center gap-3 cursor-pointer rounded-lg px-2">
            <div className="rounded-full h-10 w-10 bg-primary-600 text-white text-center flex items-center justify-center">
              <RiseOutlined size={30} />
            </div>
            <div className="text-primary-600">
              <span>{t('view_more_details')}</span>
            </div>
          </div>
        </Link>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <TotalUsers />
        <TopContributorsStats />
      </div>
    </Card>
  );
}

export default UsersEngagementStats;
